import { render } from "./SpaceFormPageFive.vue?vue&type=template&id=03f64133"
import script from "./SpaceFormPageFive.vue?vue&type=script&lang=js"
export * from "./SpaceFormPageFive.vue?vue&type=script&lang=js"
script.render = render

export default script